<span *ngIf="header" class="field-header">{{header}}</span> 
<mat-form-field style="width: 100%" [appearance]="appearance" [ngClass]="header ? 'mt-2' : ''">
  <mat-label>{{ label }}</mat-label>
  <mat-select
    [placeholder]="label ? label : 'Select'"
    [formControl]="controlName"
    [multiple]="multiSelect"
    (blur)="onBlurEvent($event)"
  >
    <mat-option *ngFor="let elm of options" [value]="elm.value" [disabled]="elm?.disabled">
      {{ elm.label }}
    </mat-option>
  </mat-select>
  <mat-icon *ngIf="hasError()" matSuffix color="warn">info</mat-icon>
  <mat-icon *ngIf="(isValid() && isOptional() && isTouched()) || (isValid() && !isOptional())" matSuffix class="icon-success">check_circle</mat-icon>
  <mat-icon *ngIf="!hasError() && !isValid()" color="primary" matSuffix >arrow_drop_down</mat-icon>
  <mat-error *ngIf="hasError()">{{ getErrorMessage() }}</mat-error>
  <!-- <mat-hint>{{ controlName.value }}</mat-hint> -->
</mat-form-field>
